import { contextConnect, useContextSystem } from '@wp-g2/context';
import React from 'react';
import { useCheckboxState } from 'reakit';
import { CheckboxGroupContext } from './CheckboxGroup.Context';

function CheckboxGroup(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'CheckboxGroup'),
      children = _useContextSystem.children,
      value = _useContextSystem.value;

  var checkbox = useCheckboxState({
    state: value
  });
  var contextProps = React.useMemo(function () {
    return {
      checkbox: checkbox
    };
  }, [checkbox]);
  return /*#__PURE__*/React.createElement(CheckboxGroupContext.Provider, {
    ref: forwardedRef,
    value: contextProps
  }, children);
}

export default contextConnect(CheckboxGroup, 'CheckboxGroup');